// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* notificationBell.css */
.notification-container {
  position: relative;
  display: inline-block;
  margin-right: 1rem;
}

.notification-bell {
  position: relative;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
}

.notification-bell:hover {
  background-color: #f3f4f6;
  color: #374151;
}

.notification-badge {
  position: absolute;
  top: -2px;
  right: -2px;
  background: #f47803ff;
  color: white;
  border-radius: 10px;
  padding: 2px 6px;
  font-size: 10px;
  font-weight: 600;
  min-width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid white;
}

.notification-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  width: 400px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 10px 25px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  z-index: 1000;
  margin-top: 8px;
  overflow: hidden;
}

.notification-dropdown::before {
  content: '';
  position: absolute;
  top: -8px;
  right: 16px;
  width: 16px;
  height: 16px;
  background: white;
  transform: rotate(45deg);
  border-left: 1px solid #e5e7eb;
  border-top: 1px solid #e5e7eb;
}

.notification-header {
  display: flex;
  align-items: center;
  justify-content: between;
  padding: 16px 20px;
  border-bottom: 1px solid #f3f4f6;
  background: #fafafa;
}

.notification-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  flex: 1 1;
}

.mark-all-read-btn {
  background: #f47803ff;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 6px 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mark-all-read-btn:hover {
  background: #f47803ff;
  transform: translateY(-1px);
}

.notification-list {
  max-height: 400px;
  overflow-y: auto;
}

.notification-loading,
.notification-empty {
  padding: 32px 20px;
  text-align: center;
  color: #6b7280;
  font-size: 14px;
}

.notification-item {
  display: flex;
  align-items: flex-start;
  padding: 16px 20px;
  border-bottom: 1px solid #f3f4f6;
  transition: background-color 0.2s ease;
  gap: 12px;
}

.notification-item:hover {
  background-color: #f9fafb;
}

.notification-item:last-child {
  border-bottom: none;
}

.notification-icon {
  flex-shrink: 0;
  margin-top: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}

.notification-content {
  flex: 1 1;
  min-width: 0;
}

.notification-subject {
  font-weight: 600;
  color: #111827;
  font-size: 14px;
  margin-bottom: 4px;
  line-height: 1.4;
}

.notification-text {
  color: #6b7280;
  font-size: 13px;
  line-height: 1.4;
  word-wrap: break-word;
}

.notification-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  flex-shrink: 0;
  margin-left: 8px;
}

.notification-time {
  font-size: 11px;
  color: #9ca3af;
  font-weight: 500;
  white-space: nowrap;
}

.mark-read-btn {
  background: #f3f4f6;
  border: none;
  border-radius: 6px;
  padding: 4px 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 4px;
  color: #6b7280;
  font-size: 11px;
  font-weight: 500;
}

.mark-read-btn:hover {
  background: #e5e7eb;
  color: #374151;
}

.mark-read-text {
  display: none;
}

.notification-footer {
  padding: 12px 20px;
  border-top: 1px solid #f3f4f6;
  background: #fafafa;
  text-align: center;
}

.view-all-btn {
  background: transparent;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 6px 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #374151;
  font-size: 13px;
  font-weight: 500;
}

.view-all-btn:hover {
  background: #f3f4f6;
  border-color: #9ca3af;
}

/* Scrollbar styling */
.notification-list::-webkit-scrollbar {
  width: 6px;
}
.navbarcontent span {
    font-size: 10px;
}

.notification-list::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.notification-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.notification-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Responsive design */
@media (max-width: 480px) {
  .notification-dropdown {
    width: 320px;
    right: -50px;
  }
  
  .notification-dropdown::before {
    right: 66px;
  }
  
  .mark-read-text {
    display: inline;
  }
  
  .notification-item {
    padding: 14px 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/Pages/NotificationBell/notificationBell.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mFAAmF;EACnF,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;EAChC,sCAAsC;EACtC,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;AACA;IACI,eAAe;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* notificationBell.css */\n.notification-container {\n  position: relative;\n  display: inline-block;\n  margin-right: 1rem;\n}\n\n.notification-bell {\n  position: relative;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #6b7280;\n}\n\n.notification-bell:hover {\n  background-color: #f3f4f6;\n  color: #374151;\n}\n\n.notification-badge {\n  position: absolute;\n  top: -2px;\n  right: -2px;\n  background: #f47803ff;\n  color: white;\n  border-radius: 10px;\n  padding: 2px 6px;\n  font-size: 10px;\n  font-weight: 600;\n  min-width: 18px;\n  height: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid white;\n}\n\n.notification-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  width: 400px;\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 10px 25px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  z-index: 1000;\n  margin-top: 8px;\n  overflow: hidden;\n}\n\n.notification-dropdown::before {\n  content: '';\n  position: absolute;\n  top: -8px;\n  right: 16px;\n  width: 16px;\n  height: 16px;\n  background: white;\n  transform: rotate(45deg);\n  border-left: 1px solid #e5e7eb;\n  border-top: 1px solid #e5e7eb;\n}\n\n.notification-header {\n  display: flex;\n  align-items: center;\n  justify-content: between;\n  padding: 16px 20px;\n  border-bottom: 1px solid #f3f4f6;\n  background: #fafafa;\n}\n\n.notification-header h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #111827;\n  flex: 1;\n}\n\n.mark-all-read-btn {\n  background: #f47803ff;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  padding: 6px 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.mark-all-read-btn:hover {\n  background: #f47803ff;\n  transform: translateY(-1px);\n}\n\n.notification-list {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.notification-loading,\n.notification-empty {\n  padding: 32px 20px;\n  text-align: center;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n.notification-item {\n  display: flex;\n  align-items: flex-start;\n  padding: 16px 20px;\n  border-bottom: 1px solid #f3f4f6;\n  transition: background-color 0.2s ease;\n  gap: 12px;\n}\n\n.notification-item:hover {\n  background-color: #f9fafb;\n}\n\n.notification-item:last-child {\n  border-bottom: none;\n}\n\n.notification-icon {\n  flex-shrink: 0;\n  margin-top: 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n}\n\n.notification-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.notification-subject {\n  font-weight: 600;\n  color: #111827;\n  font-size: 14px;\n  margin-bottom: 4px;\n  line-height: 1.4;\n}\n\n.notification-text {\n  color: #6b7280;\n  font-size: 13px;\n  line-height: 1.4;\n  word-wrap: break-word;\n}\n\n.notification-right {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n  flex-shrink: 0;\n  margin-left: 8px;\n}\n\n.notification-time {\n  font-size: 11px;\n  color: #9ca3af;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.mark-read-btn {\n  background: #f3f4f6;\n  border: none;\n  border-radius: 6px;\n  padding: 4px 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: #6b7280;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.mark-read-btn:hover {\n  background: #e5e7eb;\n  color: #374151;\n}\n\n.mark-read-text {\n  display: none;\n}\n\n.notification-footer {\n  padding: 12px 20px;\n  border-top: 1px solid #f3f4f6;\n  background: #fafafa;\n  text-align: center;\n}\n\n.view-all-btn {\n  background: transparent;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  padding: 6px 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: #374151;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.view-all-btn:hover {\n  background: #f3f4f6;\n  border-color: #9ca3af;\n}\n\n/* Scrollbar styling */\n.notification-list::-webkit-scrollbar {\n  width: 6px;\n}\n.navbarcontent span {\n    font-size: 10px;\n}\n\n.notification-list::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.notification-list::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 3px;\n}\n\n.notification-list::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n/* Responsive design */\n@media (max-width: 480px) {\n  .notification-dropdown {\n    width: 320px;\n    right: -50px;\n  }\n  \n  .notification-dropdown::before {\n    right: 66px;\n  }\n  \n  .mark-read-text {\n    display: inline;\n  }\n  \n  .notification-item {\n    padding: 14px 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
